import {Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef} from '@angular/core';
import { Asset, AssetType, AssetProviderType } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { HttpClient } from '@angular/common/http';
import { AssetsListComponent } from '@shared/components/file-manager/assets-list/assets-list.component';
import { UploadService } from '@shared/services/upload.service';
@Component({
  selector: 'ready-player-me-link',
  templateUrl: './ready-player-me-link.component.html',
  styleUrls: ['./ready-player-me-link.component.scss']
})
export class ReadyPlayerMeLinkComponent implements OnInit {
  @Input() type: AssetType;
  @Output() selected = new EventEmitter<Asset>();

  @ViewChild(AssetsListComponent, { static: false }) assetsList: AssetsListComponent;
  @ViewChild('textSearch') textSearch: ElementRef;

  pathError: Error;

  private _loading = false;

  constructor(
    private _uploadService: UploadService,
  ) { }
  ngOnInit(): void {}

  async validatePathAndCreateMedia(path: string): Promise<void> {
    this.pathError = undefined;
    this._loading = true;
    try {
      await this._uploadService.importRPM(path);
      this.assetsList.loadAssets();
      this.textSearch.nativeElement.value = '';
      this._loading = false;
    } catch (error) {
      this._loading = false;
      this.pathError = error;
    }
  }

  canSave(): boolean {
    return !this._loading;
  }

  onCurrentSelect(event: any): void {
    this.selected.emit(event); //just propagate to parent
  }

  goToHelp(): void {
    window.open('https://help.spaces.wondavr.com/en/articles/8134882-add-a-npc-annotation');
  }
}
